import {
  DataTableFeatures,
  DataTableSettings,
} from "@/types/dataTableSettings";
import { createContext, PropsWithChildren } from "react";

export const defaultDataTableFeatures: DataTableFeatures = {
  enableColumnPinning: true,
  enableColumnOrder: true,
  enableFilters: true,
  enableSorting: true,
  enableColumnVisibility: true,
  enableRowSelection: false,
  enableSelectAll: false,
  enableCopySelection: true,
  initialColumnSizes: {},
  initialColumnVisibility: {},
};

export const DataTableSettingsContext =
  createContext<DataTableSettings<unknown> | null>(null);

interface ProviderProps<T> extends PropsWithChildren {
  value: DataTableSettings<T>;
}

export function DataTableSettingsContextProvider<T>({
  children,
  value,
}: ProviderProps<T>) {
  return (
    <DataTableSettingsContext.Provider
      value={value as DataTableSettings<unknown>}
    >
      {children}
    </DataTableSettingsContext.Provider>
  );
}
